import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
import Datetime from "react-datetime";
import dayjs from "dayjs";
// nodejs library that concatenates classes
import classNames from "classnames";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import CustomSelect from '@app/components/CustomSelect/CustomSelect';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
import Divider from '@material-ui/core/Divider';
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
// icons
import SaveIcon from '@material-ui/icons/Save';
import Email from '@material-ui/icons/Email';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const AboutYourBusinessView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Webinar
    const howHearAboutVoucherError = props.validationErrors.howHearAboutVoucher.show;
    const howHearAboutVoucherHelperText = props.validationErrors.howHearAboutVoucher.show ? props.validationErrors.howHearAboutVoucher.errorMessage : '';
    // Beneficiary Details
    const personNameError = props.validationErrors.personName.show;
    const personNameHelperText = props.validationErrors.personName.show ? props.validationErrors.personName.errorMessage : '';
    
    const companyNameError = props.validationErrors.companyName.show;
    const companyNameHelperText = props.validationErrors.companyName.show ? props.validationErrors.companyName.errorMessage : '';
    
    const companyAddressError = props.validationErrors.companyAddress.show;
    const companyAddressHelperText = props.validationErrors.companyAddress.show ? props.validationErrors.companyAddress.errorMessage : '';
    
    const telephoneError = props.validationErrors.telephone.show;
    const telephoneHelperText = props.validationErrors.telephone.show ? props.validationErrors.telephone.errorMessage : '';
    
    const mobilePhoneError = props.validationErrors.mobilePhone.show;
    const mobilePhoneHelperText = props.validationErrors.mobilePhone.show ? props.validationErrors.mobilePhone.errorMessage : '';
    
    const webAddressError = props.validationErrors.webAddress.show ;
    const webAddressHelperText = props.validationErrors.webAddress.show ? props.validationErrors.webAddress.errorMessage : '';
    
    const businessTypeError = props.validationErrors.businessType.show;
    const businessTypeHelperText = props.validationErrors.businessType.show ? props.validationErrors.businessType.errorMessage : '';
    
    const croNumberError = props.validationErrors.croNumber.show;
    const croNumberHelperText = props.validationErrors.croNumber.show ? props.validationErrors.croNumber.errorMessage : '';
    
    const yearEstablishedError = props.validationErrors.yearEstablished.show;
    const yearEstablishedHelperText = props.validationErrors.yearEstablished.show ? props.validationErrors.yearEstablished.errorMessage : '';
    
    const currentOnlinePresenceError = props.validationErrors.currentOnlinePresence.show;
    const currentOnlinePresenceHelperText = props.validationErrors.currentOnlinePresence.show ? props.validationErrors.currentOnlinePresence.errorMessage : '';

    const emailError = props.validationErrors.emailAddress.show;
    const emailHelperText = props.validationErrors.emailAddress.show ? props.validationErrors.emailAddress.errorMessage : '';

    // Options Messages
    const yes = props.intl.formatMessage({ id: "yes" });
    const no = props.intl.formatMessage({ id: "no" });
    const notSure = props.intl.formatMessage({ id: "not.sure" });

    // Date vars
    const today = dayjs();
    const validWebinarDate = function( current ) {
        return today.isAfter( current );
    };
  
    return (
        <GridContainer justify='center' className={classes.whiteBG}>
            <GridItem xs={12} className={classes.whiteBG}>
                <form name="trading-online-voucher-scheme-2020">    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="howHear">
                                ABOUT YOUR BUSINESS
                            </h3>
                        </CardHeader>    
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="howHearAboutVoucher">
                                How did you hear about the Trading Online Voucher?&nbsp;
                                {props.validationErrors.howHearAboutVoucher.check === null ? ' ' : (props.validationErrors.howHearAboutVoucher.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                    <div>
                                                        <span>
                                                            This is to help your Local Enterprise with their statistics. It will help us if you write LocalPro.ie ;) .
                                                        </span>
                                                        <div className={classes.cardBodySignUpButtons}>
                                                            <Button color="primary" round
                                                                onClick={() => { props.setHowHearAboutVoucher("LocalPro.ie") }}>
                                                                <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className={classes.inputIconsColor}/>LocalPro.ie
                                                            </Button>
                                                        </div>
                                                    </div>
                                                
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='howHearAboutVoucherInput'
                                        labelText=''
                                        helperText={howHearAboutVoucherHelperText}
                                        error={howHearAboutVoucherError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'LocalPro.ie',
                                            name: 'howHearAboutVoucher',
                                            value: props.howHearAboutVoucher,
                                            onChange: props.handleHowHearAboutVoucher,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'bullhorn']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="didAttendTOVWebinar">
                                Have You Attended A TOV Webinar?&nbsp;
                                {props.validationErrors.didAttendTOVWebinar.check === null ? ' ' : (props.validationErrors.didAttendTOVWebinar.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Attendance at a Trading Online Voucher webinar is required to make an application. Is is a very useful event to learn about the uses of the voucher and will help you in choosing suppliers and services."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDidAttendTOVWebinar}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.didAttendTOVWebinar === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDidAttendTOVWebinar}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.didAttendTOVWebinar === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDidAttendTOVWebinar}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.didAttendTOVWebinar === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            {props.didAttendTOVWebinar != 'no' && <div>
                                <h4 className={classes.title} id="didAttendTOVDate">
                                    Date You Attended A TOV Webinar&nbsp;
                                    {props.validationErrors.didAttendTOVDate.check === null ? ' ' : (props.validationErrors.didAttendTOVDate.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                </h4>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomAccordion
                                            active={1}
                                            activeColor="danger"
                                            collapses={[
                                                {
                                                    title: "Help",
                                                    content:
                                                    "Enter the date of the Trading Online Voucher webinar that you attended. You won't be able to submit your application before attending a webinar. If you attended a webinar in previous years, or more than 4 months ago, you'll likely need to attend another one before being eligible to apply for the voucher."
                                                }
                                            ]}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <FormControl fullWidth>
                                            <Datetime
                                                timeFormat={false}
                                                inputProps={{ 
                                                    placeholder: "Select Date",
                                                    value: dayjs(props.didAttendTOVDate).format('dddd, MMM D, YYYY')
                                                }}
                                                onChange={props.handleDidAttendTOVDate}
                                                closeOnSelect={true}
                                                locale="en-ie"
                                                isValidDate={validWebinarDate}
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <Divider className={classes.divider}/>
                            </div>}
                            <h4 className={classes.title} id="name">
                                Your Name&nbsp;
                                {props.validationErrors.personName.check === null ? ' ' : (props.validationErrors.personName.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "The full name of the applicant. Do not write the business name here, it must be the name of the person who is making the application on behalf of the business."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='personNameInput'
                                        labelText=''
                                        helperText={personNameHelperText}
                                        error={personNameError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            name: 'personName',
                                            value: props.personName,
                                            onChange: props.handlePersonName,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'signature']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: 'FirstName LastName'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="companyName">
                                Business Name&nbsp;
                                {props.validationErrors.companyName.check === null ? ' ' : (props.validationErrors.companyName.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>The name of the business. If none, enter your own name. You may be encouraged by your LEO to <a href="https://www.cro.ie/Registration/Business-Name" target="_blank" rel="noopener">register a business name</a> (it costs about €20) with the <a href="https://www.cro.ie" target="_blank" rel="noopener">Companies Registration Office</a> before applying.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='companyNameInput'
                                        labelText=''
                                        helperText={companyNameHelperText}
                                        error={companyNameError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            name: 'companyName',
                                            value: props.companyName,
                                            onChange: props.handleCompanyName,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user-tie']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: "Business / Trading Name"
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="companyAddress">
                                Business Address&nbsp;
                                {props.validationErrors.companyAddress.check === null ? ' ' : (props.validationErrors.companyAddress.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>The address of the business. This is the address that is registered with the <a href="https://www.cro.ie" target="_blank" rel="noopener">Companies Registration Office</a> or the <a href="https://www.revenue.ie" target="_blank" rel="noopener">Revenue / tax office</a>. Basically where the business post, bank statements, bills etc. are delivered.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='companyAddressInput'
                                        labelText=''
                                        helperText={companyAddressHelperText}
                                        error={companyAddressError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'companyAddress',
                                            value: props.companyAddress,
                                            onChange: props.handleCompanyAddress,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'map-pin']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: "Unit 101 \n123 Main St. \nGalway\nA65 F4E2"

                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="telephone">
                                Telephone&nbsp;
                                {props.validationErrors.telephone.check === null ? ' ' : (props.validationErrors.telephone.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "The landline phone number of the business. If you don't have a landline, enter the main phone number of the business."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='telephoneInput'
                                        labelText=''
                                        helperText={telephoneHelperText}
                                        error={telephoneError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            name: 'telephone',
                                            value: props.telephone,
                                            onChange: props.handleTelephone,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'phone-alt']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: "091-1234567"
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="mobilePhone">
                                Mobile Number&nbsp;
                                {props.validationErrors.mobilePhone.check === null ? ' ' : (props.validationErrors.mobilePhone.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Your mobile phone number, if you have one."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='mobilePhoneInput'
                                        labelText=''
                                        helperText={mobilePhoneHelperText}
                                        error={mobilePhoneError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            name: 'mobilePhone',
                                            value: props.mobilePhone,
                                            onChange: props.handleMobilePhone,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'mobile-alt']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: "088-1234567"
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="emailAddress">
                                Email Address&nbsp;
                                {props.validationErrors.emailAddress.check === null ? ' ' : (props.validationErrors.emailAddress.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>You almost certainly have an email address. If not, get one because you'll need one to apply for this voucher. You will also need one to use most services online. Use the email address that you use for your business. It is useful to use a separate email address from a personal email address. You can get free email accounts with <a href="https://mail.google.com" target="_blank" rel="noopener">Google</a>, <a href="https://outlook.live.com" target="_blank" rel="noopener">Microsoft</a> and <a href="https://protonmail.com" target="_blank" rel="noopener">ProtonMail</a>, amongst many others, with varying degrees of security and privacy.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='emailAddress'
                                        labelText=''
                                        helperText={emailHelperText}
                                        error={emailError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            name: 'emailAddress',
                                            value: props.emailAddress,
                                            onChange: props.onEmailChange,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <Email className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            placeholder: "name@email.domain"
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="onlineOffline">
                                Website&nbsp;
                                {props.validationErrors.onlineOffline.check === null ? ' ' : (props.validationErrors.onlineOffline.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "If you have a website up-and-running, select 'Yes'. If you just have a website address but no website, or your website is down, select 'No'. If you are unsure, you need to get help from someone you trust."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineOffline}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'signal']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'signal']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.onlineOffline === 'online'}
                                                name="online"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="online"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineOffline}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'power-off']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'power-off']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="offline"
                                                checked={props.onlineOffline === 'offline'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="offline"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineOffline}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.onlineOffline === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            {props.onlineOffline != 'offline' && <div>
                                <h4 className={classes.title} id="webAddress">
                                    Website Address&nbsp;
                                    {props.validationErrors.webAddress.check === null ? ' ' : (props.validationErrors.webAddress.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                </h4>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomAccordion
                                            active={1}
                                            activeColor="danger"
                                            collapses={[
                                                {
                                                    title: "Help",
                                                    content:
                                                    "The address of your website, if you have one. If you don't have one, in most cases, you'll be expected to create one with this voucher. If you already have one and it needs upgrading, you'll likely be expected to upgrade it with this voucher."
                                                }
                                            ]}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomInput
                                            id='webAddressInput'
                                            labelText=''
                                            helperText={webAddressHelperText}
                                            error={webAddressError}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                name: 'webAddress',
                                                value: props.webAddress,
                                                onChange: props.onWebsiteChange,
                                                autoComplete: 'off',
                                                startAdornment: (
                                                    <InputAdornment position='start'>
                                                        <FontAwesomeIcon icon={['fas', 'globe']} className={classes.inputIconsColor} />
                                                    </InputAdornment>
                                                ),
                                                placeholder: "MyBrilliantWebsite.ie"
                                            }}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <Divider className={classes.divider}/>
                            </div>}
                            <h4 className={classes.title} id="businessType">
                                Business Type&nbsp;
                                {props.validationErrors.businessType.check === null ? ' ' : (props.validationErrors.businessType.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>You may be encouraged by your LEO to <a href="https://www.cro.ie/Registration/Business-Name" target="_blank" rel="noopener">register a business name</a> (it costs about €20) with the <a href="https://www.cro.ie" target="_blank" rel="noopener">Companies Registration Office</a> before applying.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomSelect
                                        id='businessType'
                                        helperText={businessTypeHelperText}
                                        error={businessTypeError}
                                        labelText=''
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        selectProps={{
                                            value: props.businessType,
                                            onChange: props.handleBusinessType,
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['far', 'building']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                        inputProps={{
                                            name: 'businessType',
                                            id: 'businessType'
                                        }}
                                        options={props.bizTypes} />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="croNumber">
                                CRO Number&nbsp;
                                {props.validationErrors.croNumber.check === null ? ' ' : (props.validationErrors.croNumber.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>The business number that is available from the Companies Registration Office. It was previously not required to have one, but it seems that it may now be a requirement. It costs about €20 to get one from the <a href="https://www.cro.ie" target="_blank" rel="noopener">Companies Registration Office</a>.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='croNumberInput'
                                        labelText=''
                                        helperText={croNumberHelperText}
                                        error={croNumberError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '123456',
                                            name: 'croNumber',
                                            value: props.croNumber,
                                            onChange: props.handleCroNumber,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'dice']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="yearEstablished">
                                Year Established&nbsp;
                                {props.validationErrors.yearEstablished.check === null ? ' ' : (props.validationErrors.yearEstablished.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>Enter the year in which the business was established. To be eligible, a business must be trading for a minimum of 6 months. If there has not already being a yearly tax return completed, proof of trading such as a paid invoice will be required. If a business has been established for more than 6 months without sales, it will <b>not be</b> considered as being <b>trading</b> for a minimum of 6 months.</span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomSelect
                                        id='yearEstablished'
                                        helperText={yearEstablishedHelperText}
                                        error={yearEstablishedError}
                                        labelText=''
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        selectProps={{
                                            value: props.yearEstablished,
                                            onChange: props.handleYearEstablished,
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'business-time']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                        inputProps={{
                                            name: 'yearEstablished',
                                            id: 'yearEstablished'
                                        }}
                                        options={props.years} />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                            <h4 className={classes.title} id="currentOnlinePresence">
                                Your Current Online Presence&nbsp;
                                {props.validationErrors.currentOnlinePresence.check === null ? ' ' : (props.validationErrors.currentOnlinePresence.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Describe your current online presence. You say none if that's the case. Otherwise it may be something like a brochure site, a shopify site, a full e-commerce site, social media accounts, etc."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='currentOnlinePresenceInput'
                                        helperText={currentOnlinePresenceHelperText}
                                        error={currentOnlinePresenceError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: "Facebook Page \nTwitter Account",
                                            multiline: true,
                                            rows: 6,
                                            name: 'currentOnlinePresence',
                                            value: props.currentOnlinePresence,
                                            onChange: props.handleCurrentOnlinePresence,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'globe']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Divider className={classes.divider}/>
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_GRANT}>
                                    &lt;&lt; Grant History 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_DESCRIBE}>
                                    Describe Your Business &gt; 
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

AboutYourBusinessView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    // Application Form
    // Stats
    setHowHearAboutVoucher: PropTypes.func.isRequired,
    handleHowHearAboutVoucher: PropTypes.func.isRequired,
    handleDidAttendTOVWebinar: PropTypes.func.isRequired,
    handleDidAttendTOVDate: PropTypes.func.isRequired,
    // Beneficiary Details
    handlePersonName: PropTypes.func.isRequired,
    handleCompanyName: PropTypes.func.isRequired,
    handleCompanyAddress: PropTypes.func.isRequired,
    handleTelephone: PropTypes.func.isRequired,
    handleMobilePhone: PropTypes.func.isRequired,
    handleOnlineOffline: PropTypes.func.isRequired,
    handleBusinessType: PropTypes.func.isRequired,
    handleCroNumber: PropTypes.func.isRequired,
    handleYearEstablished: PropTypes.func.isRequired,
    handleCurrentOnlinePresence: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onWebsiteChange: PropTypes.func.isRequired,
    validationErrors: PropTypes.object.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(AboutYourBusinessView));